import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InsightspopupService } from '../../services/insightspopup.service';
import { InsightsModel } from '../../models/common.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-insights-popup-aesthetics',
  templateUrl: './insights-popup-aesthetics.component.html',
  styleUrls: ['./insights-popup-aesthetics.component.css']
})
export class InsightsPopupAestheticsComponent {
  headerTitle: string = "Error";
  messageText: string = "";
  buttonText: string = "Ok"
  showError: boolean = false;
  $unSubscribeInsightsDAta!: Subscription;
  showLoader: boolean = true;
  @Output() isInsightspopupOpen = new EventEmitter<any>();

  constructor(private _insightsService: InsightspopupService) {

  }
  ngOnInit() {
    this.showLoader = false;
    this.$unSubscribeInsightsDAta! = this._insightsService.isInsights$.subscribe((insights: InsightsModel) => {
      this.showError = insights.show;
      this.headerTitle = insights.header;
      this.messageText += insights.message;
      this.showLoader = insights.show;
    });
  }
  ngOnDestroy() {
    if (this.$unSubscribeInsightsDAta) {
      this.$unSubscribeInsightsDAta.unsubscribe();
    }
  }
  close() {
    this.clearMessage();
    this.isInsightspopupOpen.emit({ isInsightspopupOpen: false });
  }

  clearMessage() {
    setTimeout(() => {
      this.messageText = "";
      this.showLoader = false;
    }, 500);
  }
}
